import React, { useMemo } from 'react';
import styled from 'styled-components';
import { FaWhatsapp } from 'react-icons/fa';
import { useAppSelector } from '../../store/hooks';
import { ehPlanoGratuito, estaEmPeriodoDeTeste, obterDataCadastro } from '../../services/seguranca';

const DIAS_LIMITE_ASSINANTE_RECENTE = 45;
const NUMERO_WHATSAPP = '5585988885089';
const MENSAGEM_PADRAO = 'Olá! Sou cliente da LocaSmartPro e gostaria de agendar um treinamento de implantação.';

const Botao = styled.button`
  background: none;
  border: 1px solid #25D366;
  color: #128C4B;
  padding: 5px 10px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 500;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 5px;
  transition: all 0.2s ease;
  margin-right: 6px;
  white-space: nowrap;
  flex-shrink: 0;

  &:hover {
    background-color: #25D366;
    color: white;
  }

  @media (max-width: 900px) {
    font-size: 0;
    gap: 0;
    padding: 6px;

    svg { font-size: 14px; }
  }
`;

function ehAssinanteRecente(token: string): boolean {
  if (!token) return false;
  if (estaEmPeriodoDeTeste(token)) return false;
  if (ehPlanoGratuito(token)) return false;

  const dataStr = obterDataCadastro(token);
  if (!dataStr) return false;

  const dataCadastro = new Date(dataStr);
  if (isNaN(dataCadastro.getTime())) return false;

  const diasDesdeCadastro = (Date.now() - dataCadastro.getTime()) / (1000 * 60 * 60 * 24);
  return diasDesdeCadastro >= 0 && diasDesdeCadastro <= DIAS_LIMITE_ASSINANTE_RECENTE;
}

export const BotaoImplantacao: React.FC = () => {
  const token = useAppSelector(state => state.token);

  const mostrar = useMemo(() => ehAssinanteRecente(token), [token]);

  if (!mostrar) return null;

  const abrirWhatsApp = () => {
    const url = `https://wa.me/${NUMERO_WHATSAPP}?text=${encodeURIComponent(MENSAGEM_PADRAO)}`;
    window.open(url, '_blank', 'noopener,noreferrer');
  };

  return (
    <Botao onClick={abrirWhatsApp} title="Agendar treinamento de implantação">
      <FaWhatsapp size={14} />
      Agendar Implantação
    </Botao>
  );
};
